<template>
  <div class="details-card"
    :class="{ 'border-top-outline-success': data.calfStatus || data.calfArchiveDate, 'border-top-outline-danger': !data.calfStatus && !data.calfArchiveDate }">
    <div class="card-header">
      <div class="float-start ms-1 fs-3">
        <i class="fas fa-sync rotate" @click="this.$router.go()"></i>
      </div>
      <div class="float-end" style="margin-top: -25px">
        <span class="badge bg-warning text-dark" v-if="this.data.calfDesc[0]?.stress">{{ $t('health.receivingTreatment')
          }}</span>
        <span class="badge bg-success" v-else>{{ $t('health.healthy') }}</span>
      </div>
    </div>
    <div class="card-body">
      <div class="card-img">
        <img src="@/assets/media/img/calf.png" alt="" />
      </div>
      <div class="card-list">
        <p class="card-item" v-if="data.calfArchiveDate">
          <span class="desc">{{ $t('table.archiveDate') }}</span>
          {{ data.calfArchiveDate }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('table.date') }}</span>
          {{ data.calfArchiveDate ? data.calfStatistic[0]?.date : data.statistic?.date }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('title') }}</span>
          {{ data.calfTitle }}
        </p>
        <p class="card-item" v-if="this.calfGenderList.filter(x => x.type == data.calfGender).length > 0">
          <span class="desc">{{ $t('gender') }}</span>
          {{this.calfGenderList.filter(x => x.type == data.calfGender)[0].desc}}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('code') }}</span>
          {{ data.calfCode }}
        </p>
        <p class="card-item"
          v-if="this.systems?.liquitSuplament || this.systems?.liquitSuplament2 || this.systems?.powderSuplament">
          <span class="desc">{{ $t('support') }}</span>
          <span>
            <span class="badge bg-info me-1" v-if="this.systems?.liquitSuplament">
              {{ data.statistic?.liquitSuplament || 0 }}
              <i class="fas fa-tint"></i>
            </span>
            <span class="badge bg-info me-1" v-if="this.systems?.liquitSuplament2">
              {{ data.statistic?.liquitSuplament2 || 0 }}
              <i class="fas fa-tint"></i>
            </span>
            <span class="badge bg-info me-1" v-if="this.systems?.powderSuplament">
              {{ data.statistic?.powderSuplament || 0 }}
              <i class="fas fa-tty"></i>
            </span>
          </span>
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('type') }}</span>
          {{ calfType[data.calfTypeID] }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('table.registerDate') }}</span>
          {{ `${data.calfFeedingStartDate} (${data.calfArchiveDate ? this.$moment.dateDiff(data.calfArchiveDate, data.calfFeedingStartDate, 'days') : this.$moment.daysDiff(data.calfFeedingStartDate) * -1} ${$t('day')})` }}
        </p>
        <p class="card-item" v-if="data.calfArchiveDate">
          <span class="desc">{{ $t('feeding.type') }}</span>
          <span>{{ data.statistic?.feedingType }}</span>
        </p>
        <p class="card-item" v-if="data.calfSpecialPeriodDetails">
          <span class="desc">{{ $t('table.period') }}</span>
          {{
            `${data.calfSpecialPeriodDetails.startDay} -
          ${data.calfSpecialPeriodDetails.endDay}`
          }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('input.birthDay') }}</span>
          {{ `${data.calfBirthDayDate} (${data.calfArchiveDate ? this.$moment.dateDiff(data.calfArchiveDate, data.calfBirthDayDate, 'days') : this.$moment.daysDiff(data.calfBirthDayDate) * -1} ${$t('day')})` }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('feeding.n_time') }}</span>
          {{ `${data.statistic?.totalFeedingDay || data.calfFeedingDayCount} ${$t('day')}` }}
        </p>
        <p class="card-item" v-if="!data.calfArchiveDate">
          <span class="desc">{{ $t('remainder') }}</span>
          {{ `${data.statistic?.remainderDay} ${$t('day')}` }}
        </p>
        <p class="card-item" v-if="!data.calfArchiveDate">
          <span class="desc">{{ $t('feeding.claim') }}</span>
          {{
            `${this.$filters.formatL(data.statistic?.totalConsumption)} /
          ${this.$filters.formatL(data.statistic?.totalClaim)}`
          }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('feeding.totalVisits') }}</span>
          {{ data.calfArchiveDate ? data.calfStatistic[0]?.visitCount : data.statistic?.visitCount }}
        </p>
        <p class="card-item">
          <span class="desc">{{ $t('feeding.n_totalConsumption') }}</span>
          {{ `${this.$filters.formatL(data.calfArchiveDate ? (data.calfStatistic[0]?.totalConsumption || 0) : (data.statistic.allTotalConsumption || 0))} ${(data?.statistic?.totalFood ?? data.calfStatistic[0]?.totalFood) ? `(${this.$filters.formatKG(data?.statistic?.totalFood || data.calfStatistic[0]?.totalFood || 0)} ${ $t('feed') })` : ''}` }}
        </p>
        <p class="card-item" v-if="this.systems?.liquitSuplament">
          <span class="desc">{{ `${$t('calf.liquitSuplament')} 1` }}</span>
          {{ this.$filters.formatL(data.calfArchiveDate ? data.calfStatistic[0]?.totalLiquitSuplament || 0 : data.statistic?.totalLiquitSuplament || 0) }}
        </p>
        <p class="card-item" v-if="this.systems?.liquitSuplament2">
          <span class="desc">{{ `${$t('calf.liquitSuplament')} 2` }}</span>
          {{ this.$filters.formatL(data.calfArchiveDate ? data.calfStatistic[0]?.totalLiquitSuplament2 || 0 : data.statistic?.totalLiquitSuplament2 || 0) }}
        </p>
        <p class="card-item" v-if="this.systems?.powderSuplament">
          <span class="desc">{{ `${$t('calf.powderSuplament')} 1` }}</span>
          {{ this.$filters.formatL(data.calfArchiveDate ? data.calfStatistic[0]?.totalPowderSuplament || 0 : data.statistic?.totalPowderSuplament || 0) }}
        </p>
        <hr />
        <div v-if="data.calfDesc[0]?.ebeveynData">
          <p class="card-item">
            <span class="desc">{{ $t('calf.input.motherBirthDay') }}</span>
            {{ data.calfDesc[0]?.ebeveynData?.motherBirthDayDate }}
          </p>
          <p class="card-item">
            <span class="desc">{{ $t('calf.input.motherCode') }}</span>
            {{ data.calfDesc[0]?.ebeveynData?.motherCode }}
          </p>
          <p class="card-item">
            <span class="desc">{{ $t('calf.input.fatherBirthDay') }}</span>
            {{ data.calfDesc[0]?.ebeveynData?.fatherBirthDayDate }}
          </p>
          <p class="card-item">
            <span class="desc">{{ $t('calf.input.fatherCode') }}</span>
            {{ data.calfDesc[0]?.ebeveynData?.fatherCode }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'no_data',
  props: {
    data: { type: Object, required: true }
  },
  data() {
    return {
      calfGenderList: [
        {
          type: 'X',
          desc: this.$t('unknown')
        },
        {
          type: 'F',
          desc: this.$t('female')
        },
        {
          type: 'M',
          desc: this.$t('male')
        }
      ]
    }
  },
  mounted() {
  },
  computed: {
    systems() {
      return this.$store.state.systems;
    },
    calfType() {
      return this.$store.state.calfType;
    }
  },
};
</script>
